import React from 'react';
import { Box } from '@bechtel/gds';

// TODO : Basic implementation only. Get hifi design and revisit this component
export const Message = ({ children }) => {
  return (
    <Box alignItems={{ sm: 'center' }} justifyContent={{ sm: 'center' }} p={{ sm: '400' }}>
      {children}
    </Box>
  );
};
